// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\ntr[data-v-34a3f782],\nthead[data-v-34a3f782],\ntbody[data-v-34a3f782],\ntd[data-v-34a3f782] {\n  text-align: center;\n}\n#table-component h4[data-v-34a3f782] {\n  display: table-cell;\n}\n", ""]);
// Exports
module.exports = exports;
